import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { LocaleService } from './locale.service';

@Injectable({
  providedIn: 'root'
})
export class CollectiveService {

  constructor(
    private http: HttpClient,
    private localeService: LocaleService,
  ) {
  }

  getPublicData() {
    let serviceUrl = `${environment.apiUrl}/${environment.apiVersion}/public/collective/${environment.apiKey}/?l=${this.localeService.getLocale()}`;

    return new Promise((resolve, reject) => {
      this.http.get(serviceUrl)
      .subscribe(
        data => {
          if (data['code'] == 200) {
            resolve(data['data']);
          }
        }
      );
    });
  }
}
